import Tasks from 'APP/Tasks';
import { ScheduleSettingsPopup } from 'APP/main/PopupManager/Popups/ScheduleSettingsPopup/ScheduleSettingsPopup';
import Entities from 'STORE';
import { Schedule } from 'STORE/Groups/Schedule';
import { VoicePayload } from 'STORE/Messages/Message/Payload/VoicePayload/VoicePayload';

export async function scheduleVoiceMessage(groupId: string): Promise<boolean> {
  let group = Entities.GroupsStore.getGroupById(groupId);
  group = group instanceof Schedule ? group.parentGroup : group;
  if (!group) {
    return false;
  }

  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  if (inputPanel.voice.isRecording) {
    await inputPanel.voice.stop();
  }

  const data = await inputPanel.voice.getVoiceData();
  const payload = new VoicePayload({
    fileName: data.file.name,
    fileSize: data.file.size,
    mimeType: data.file.type,
    userFile: data.file,
    duration: data.duration,
    histogram: data.histogram,
  });

  const canSend = Tasks.messaging.canSendMessage({ groupId, payload, isCheckSlowMode: false });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return false;
  }

  Tasks.app.openPopup(ScheduleSettingsPopup, {
    params: {
      onSubmit: async (date: Date): Promise<void> => {
        const result = await Tasks.messaging.createScheduledMessage(group.id, {
          payload,
          scheduleTime: date.getTime(),
          repliedMessage: inputPanel?.replyMessage || undefined,
          quote: inputPanel?.quote || undefined,
        });

        if (result) {
          Tasks.group.setActiveGroup({ groupId: group.scheduleGroupId });
        }
      },
    },
  });

  return true;
}
